import { STATUSES } from '@/const/status'
import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    statuses: STATUSES,
    credentialSamples: [],
    totalRows: 0,
  },
  getters: {
    statuses: state => state.statuses,
    credentialSamples: state => state.credentialSamples,
    totalRows: state => state.totalRows,
  },
  mutations: {
    SET_STATUSES: (state, statuses) => {
      state.statuses = statuses
    },
    SET_CREDENTIAL_SAMPLES: (state, credentialSamples) => {
      state.credentialSamples = credentialSamples
    },
    SET_TOTAL_ROWS: (state, data) => {
      state.totalRows = data
    },
  },
  actions: {
    async readCredentialSamples({ commit }, params) {
      try {
        const response = await axios.get('certificates/credential_samples', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_CREDENTIAL_SAMPLES', records)
          commit('SET_TOTAL_ROWS', total)
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async createCredentialSample({ commit }, params) {
      try {
        const response = await axios.post('certificates/credential_samples', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateCredentialSample({ commit }, params) {
      try {
        const response = await axios.put(`certificates/credential_samples/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteCredentialSample({ commit }, id) {
      try {
        const response = await axios.delete(`certificates/credential_samples/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async getCredentialSample({ commit },id) {
      try {
        const response = await axios.get(`certificates/credential_samples/getSample?id=${id}`)
        const { data } = response
        return { data }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
